function initializeProductQuantities(){
  document.querySelectorAll('.product-quantity').forEach(group=>{
    if(group.dataset.ready)return;
    const input=group.querySelector('input[name=quantity]');
    const minus=group.querySelector('[data-product-step="-1"]');
    const plus=group.querySelector('[data-product-step="1"]');
    if(!input||!minus||!plus)return;
    function sync(){
      const value=Number(input.value),min=Number(input.min||1);
      minus.disabled=input.disabled||input.value===''||!Number.isFinite(value)||value<=min;
      plus.disabled=input.disabled||(input.max!==''&&value>=Number(input.max));
    }
    group.querySelectorAll('[data-product-step]').forEach(button=>{
      button.hidden=false;
      button.addEventListener('click',()=>{
        if(input.value===''||!Number.isFinite(Number(input.value)))input.value=input.min||'1';
        else if(button.dataset.productStep==='1')input.stepUp();
        else input.stepDown();
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
        sync();
      });
    });
    input.addEventListener('input',sync);input.addEventListener('change',sync);
    group.dataset.ready='true';sync();
  });
}
document.addEventListener('DOMContentLoaded',initializeProductQuantities);
document.addEventListener('shopify:section:load',initializeProductQuantities);
